import i from "react";
import { getZonedDate as f } from "../utils/date-time/index.js";
import { g as y } from "./get-is-open-24-hours.BowCHFXK.js";
const F = (n, s, r) => {
  const [e, a] = i.useState(), [o, c] = i.useState(null), [u, p] = i.useState(null), t = r ? y(r) : !1;
  return i.useEffect(() => {
    const l = () => a(/* @__PURE__ */ new Date());
    if (!t) {
      l();
      const O = setInterval(l, 5 * 60 * 1e3);
      return () => clearInterval(O);
    }
  }, [t]), i.useEffect(() => {
    t || (e !== void 0 && n && c(f(n, e.getTimezoneOffset())), e !== void 0 && s && p(f(s, e.getTimezoneOffset())));
  }, [s, e, t, n]), !n || !s ? {
    isFacilityCurrentlyOpen: void 0,
    isOpen24Hours: void 0
  } : t ? {
    isFacilityCurrentlyOpen: !0,
    isOpen24Hours: t
  } : {
    isFacilityCurrentlyOpen: o !== null && u !== null && e !== void 0 && e >= o && e < u,
    isOpen24Hours: t
  };
};
export {
  F as u
};
